import React from "react";

const BRANDS = [
  "Dior",
  "Chanel",
  "Tom Ford",
  "D&G",
  "Armani",
  "Kayali",
  "Creed",
  "Maison Margiela",
  "Jo Malone",
  "Byredo",
  "Bvlgari",
  "Guerlain",
];

export default function Brands() {
  return (
    <section className="py-10 bg-white border-y border-gray-100 overflow-hidden">
      <div className="flex">
        <ul className="flex items-center animate-marquee shrink-0 list-none m-0 p-0">
          {[...BRANDS, ...BRANDS].map((brand, index) => (
            <li key={`${brand}-${index}`} className="flex items-center shrink-0">
              <span className="font-display text-lg sm:text-xl font-semibold text-gray-300 hover:text-brand-charcoal transition-colors duration-300 cursor-default whitespace-nowrap tracking-wider px-8">
                {brand}
              </span>
              <span className="text-gray-200 text-lg select-none px-2">|</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
